module.exports = __webpack_public_path__ + "img/sasa-posloncec.d6fbffb4.jpg";